import EditActionForm from './EditActionForm';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function EditActionModal({ 
  showModal, 
  actionItemToEdit, 
  handleCloseEditActionModal, 
  dsrId, 
  mapCategoryId 
}) {

  return (
    <LaunchdeckModal
      title='Edit action'
      handleCloseModal={handleCloseEditActionModal}
      showModal={showModal}
      maxW='35em'
    >
      <EditActionForm
        dsrId={dsrId}
        mapCategoryId={mapCategoryId}
        actionItemToEdit={actionItemToEdit}
        handleCloseEditActionModal={handleCloseEditActionModal}
      />

    </LaunchdeckModal>
  )



}
